<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;">
				<s-header-top></s-header-top>
			</el-header>
			<el-header class="header">
				<s-header></s-header>
			</el-header>
			<el-main>				
				<div class="content">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<span style="float: left;">当前位置：</span>
						<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/platformEvents' }">平台大事</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/platformEventsDetail' }">详情</el-breadcrumb-item>
					</el-breadcrumb>
						
					<div class="page">
						<div class="page_body">
							<el-row class="name mar_bottom">{{item.title}}</el-row>
							<el-row class="mark top_lab_box mar_bottom">
								<el-col :span="12">政策来源：{{item.source}}</el-col>
								<el-col :span="12">发布时间：{{item.createDate}}</el-col>
							</el-row>
							<el-row class="remark mar_bottom">
								<p v-html='item.content'></p>
							</el-row>
						</div>
					</div>
				</div>
			</el-main>
			<el-footer class="footer">
				<s-footer></s-footer>
			</el-footer>
			<el-footer class="copy-right">
				<s-copyRight></s-copyRight>
			</el-footer>
		</el-scrollbar>
	</el-container>	
</template>

<script>
import sHeaderTop from '@/components/header_top'
import sHeader from '@/components/header'
import sFooter from '@/components/footer'
import sCopyRight from '@/components/copy-right'
import { platformEventsDetail } from '@/api';
export default {
  name: 'platformEventsDetail',
  components:{
	sHeaderTop,
	sHeader,
	sFooter,
	sCopyRight
  },  
  data () {
    return {
		id: '',
		item: null
    }
  },
  mounted(option) {
	this.id = this.$route.query.id,  //接受参数关键代码
  	this.getPlatformEventsDetail(this.id)
  },
  methods:{
	  getPlatformEventsDetail(id){
		  let _this = this
		  platformEventsDetail({
		  	id: id
		  }).then(res=> {
		  	_this.item = res.data
		  })
	  }
  }
}
</script>

<style lang="scss" scoped>

.page_body{
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.name{
	line-height: 40px;
	margin-top: 10px;
	text-align: center;
	color: rgba(16, 16, 16, 1);
	font-size: 24px;	
}

.remark{
	width: 100%;
	>>> img{
		width:100%;
	}
}


</style>



// WEBPACK FOOTER //
// src/views/platformEvents-detail.vue